import { Link } from "react-router-dom";
import { mangaList } from "@/mocks/mangaList";
import SectionHeading from "@/components/feature/SectionHeading";

export default function HotRanking() {
  const ranking = [...mangaList].sort((a, b) => b.rating - a.rating).slice(0, 8);
  const editorPicks = mangaList.filter((m) => m.isHot).slice(0, 3);
  const rankColors = ["text-primary-500", "text-secondary-500", "text-accent-600"];

  return (
    <section className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16" aria-labelledby="ranking-heading">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <SectionHeading title="人气排行榜" subtitle="根据读者热度实时更新" moreTo="/category" moreLabel="全站排行" />
          <div className="flex flex-col gap-2.5">
            {ranking.map((manga, index) => (
              <Link
                key={manga.id}
                to={`/article/${manga.latestChapterId}`}
                className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-100/60 px-4 py-3 transition-all hover:border-primary-300 hover:bg-background-50"
                title={`阅读${manga.title}漫画`}
              >
                <span
                  className={`w-8 shrink-0 text-center font-heading text-xl font-bold ${
                    index < 3 ? rankColors[index] : "text-foreground-300"
                  }`}
                >
                  {index + 1}
                </span>
                <div className="relative h-16 w-12 shrink-0 overflow-hidden rounded-md">
                  <img
                    src={manga.cover}
                    alt={`${manga.title}漫画封面`}
                    title={`${manga.title}漫画在线阅读`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <h3 className="truncate text-sm font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
                    {manga.title}
                    <span className="ml-2 text-xs font-normal text-foreground-400">{manga.titleEn}</span>
                  </h3>
                  <p className="mt-1 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-500">
                    <span>{manga.author}</span>
                    <span className="flex items-center gap-0.5">
                      <i className="ri-fire-fill text-primary-500" aria-hidden="true" />
                      {manga.views}人气
                    </span>
                    <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-foreground-600">{manga.status}</span>
                  </p>
                </div>
                <div className="hidden shrink-0 text-right sm:block">
                  <p className="font-heading text-lg font-bold text-primary-600">{manga.rating}</p>
                  <p className="mt-0.5 max-w-32 truncate text-xs text-foreground-400">{manga.latestChapter}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>

        <div>
          <SectionHeading title="编辑推荐" moreTo="/category/hot-blooded" moreLabel="查看更多" />
          <div className="flex flex-col gap-3">
            {editorPicks.map((manga) => (
              <Link
                key={manga.id}
                to={`/article/${manga.latestChapterId}`}
                className="group relative block overflow-hidden rounded-lg"
                title={`编辑推荐:${manga.title}漫画`}
              >
                <img
                  src={manga.cover}
                  alt={`${manga.title}漫画封面`}
                  title={`${manga.title}漫画免费阅读`}
                  className="h-36 w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/30 to-transparent" aria-hidden="true" />
                <div className="absolute inset-x-0 bottom-0 px-4 pb-3">
                  <p className="mb-1 inline-flex items-center gap-1 rounded-full bg-accent-500 px-2 py-0.5 text-xs font-medium text-background-50">
                    <i className="ri-star-fill" aria-hidden="true" />
                    编辑推荐
                  </p>
                  <h3 className="truncate text-sm font-bold text-background-50">{manga.title}</h3>
                  <p className="mt-0.5 truncate text-xs text-background-50/75">{manga.description.slice(0, 26)}…</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}